import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "lg:container lg:mx-auto pt-10 md:pt-12" }
const _hoisted_2 = { class: "px-4 lg:px-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "font-ops" }, "My Farming Pools", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Stake FLAKE ")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "mb-16" }, null, -1)
const _hoisted_6 = { class: "px-4 lg:px-0" }
const _hoisted_7 = { class: "font-ops mb-3" }
const _hoisted_8 = { class: "flex flex-col md:flex-row w-full justify-between items-end lg:items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalBtn = _resolveComponent("BalBtn")!
  const _component_BalStack = _resolveComponent("BalStack")!
  const _component_MyFarmPoolsTable = _resolveComponent("MyFarmPoolsTable")!
  const _component_TokenSearchInput = _resolveComponent("TokenSearchInput")!
  const _component_FarmPoolsTable = _resolveComponent("FarmPoolsTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isWalletReady)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_BalStack, {
              horizontal: "",
              justify: "between",
              align: "center"
            }, {
              default: _withCtx(() => [
                _hoisted_3,
                _createVNode(_component_BalBtn, {
                  onClick: _ctx.navigateToStakeFlake,
                  color: "gray-950",
                  changeType: "farm",
                  size: "sm"
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_MyFarmPoolsTable, {
            pools: _ctx.pools,
            isLoading: _ctx.isLoadingUserPools || _ctx.isLoadingUserInfos,
            data: _ctx.userPools,
            userInfos: _ctx.userInfos,
            noPoolsLabel: _ctx.$t('noInvestments'),
            showMigrationColumn: _ctx.showMigrationColumn,
            selectedTokens: _ctx.selectedTokens,
            class: "mb-8",
            key: 
          `userPoolsTable-${
            _ctx.showMigrationColumn ? 'withMigrationCol' : 'withoutMigrationCol'
          }`
        
          }, null, 8, ["pools", "isLoading", "data", "userInfos", "noPoolsLabel", "showMigrationColumn", "selectedTokens"]),
          _hoisted_5
        ], 64))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.$t('farmingPools')), 1),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_TokenSearchInput, {
          modelValue: _ctx.selectedTokens,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectedTokens = $event)),
          loading: _ctx.isLoadingPools,
          onAdd: _ctx.addSelectedToken,
          onRemove: _ctx.removeSelectedToken,
          class: "w-full md:w-2/3"
        }, null, 8, ["modelValue", "loading", "onAdd", "onRemove"])
      ])
    ]),
    _createVNode(_component_FarmPoolsTable, {
      isLoading: _ctx.isLoadingPools,
      data: _ctx.filteredPools,
      noPoolsLabel: _ctx.$t('noPoolsFound'),
      isPaginated: _ctx.poolsHasNextPage,
      isLoadingMore: _ctx.poolsIsFetchingNextPage,
      onLoadMore: _ctx.loadMorePools,
      selectedTokens: _ctx.selectedTokens,
      class: "mb-8"
    }, null, 8, ["isLoading", "data", "noPoolsLabel", "isPaginated", "isLoadingMore", "onLoadMore", "selectedTokens"])
  ]))
}